import { useCharacters } from "../../../contexts/Characters"
import { Roles } from "../../../utilities/constants"
import Tabs from "../../core/Tabs/Tabs"
import CharactersApprovals from "../../domain/CharactersApprovals/CharactersApprovals"

export const Approvals = ({}) => {
    const characters = useCharacters()

    const tabs = [
        {
            name: 'server',
            label: 'Server',
            notification: characters.$state?.server?.pending?.length,
            authorized: characters.authorized([Roles.developer, Roles.admin]),
            Component: () => <CharactersApprovals scope="server" />
        },
        {
            name: 'alliance',
            label: 'Alliance',
            notification: characters.authorized([Roles.developer, Roles.admin]) 
                ? characters.$state?.server?.pendingAlliance?.filter((character) => character.alliance).length
                : characters.$state?.alliance?.pending?.filter((character) => character.alliance).length,
            authorized: characters.authorized([Roles.developer, Roles.admin, Roles.leader]),
            Component: () => <CharactersApprovals scope="alliance" />
        }
    ].filter((tab) => tab.authorized)

    return (
        <div className="container-fluid">
            {tabs.length && (
                <div className="row justify-content-center">
                    <Tabs tabs={tabs} />
                </div>
            )}
        </div>
    )
}

export default Approvals